import {createContext, useContext} from "react";
import UIManager from "../services/UIManager";

export const Context = createContext(new UIManager());
export const useUIManager = () => useContext(Context);
